import { useApolloClient } from '@apollo/client/react';

import { endSession } from '@/api/session';

/**
 * Выход из аккаунта: бэкенд отзывает refresh-куку, сессия сбрасывается во всех
 * вкладках (`endSession`). На вход уводит ProtectedRoute. Подтверждения не
 * требует — действие обратимо повторным входом (ux.md).
 */
const useLogout = (): (() => void) => {
  const client = useApolloClient();

  return (): void => {
    void endSession(client);
  };
};

export default useLogout;
